import * as ProfileTypes from './profileTypes';

export const setFirstName = (firstName) => ({ type: ProfileTypes.SET_FIRST_NAME, payload: { firstName } });

export const setLastName = (lastName) => ({ type: ProfileTypes.SET_LAST_NAME, payload: { lastName } });

export const setBirthdate = (birthdate) => ({ type: ProfileTypes.SET_BIRTHDATE, payload: { birthdate } });

export const clearState = () => ({ type: ProfileTypes.CLEAR_STATE });
